import {makeStyles} from '@mui/styles'

const useStyles = makeStyles(({palette, breakpoints, spacing}) => ({
  boldText: {
    fontFamily: 'CamptonMedium',
  },
  blockQuote: {
    display: 'flex',
    minHeight: spacing(3),
    padding: spacing(2, 0),
    '& p': {
      margin: 0,
    },
  },
  quoteDecoration: {
    width: 7,
    backgroundColor: palette.background.gray,
  },
  textBlockQuote: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: spacing(3),
  },
  embeddedVideo: {
    display: 'flex',
    justifyContent: 'center',
    padding: spacing(3, 0),
  },
  embeddedImage: {
    textAlign: 'center',
    margin: 'auto',
    padding: spacing(4, 0),
    justifyContent: 'center',
    '& img': {
      maxWidth: '100%',
      borderRadius: spacing(5, 1),
    },
    [breakpoints.down('sm')]: {
      '& img': {
        width: '100% !important',
      },
    },
  },
  link: {
    color: palette.primary.main,
    textDecoration: 'none',
    textTransform: 'none',
    fontFamily: 'CamptonLight',
    '&:hover': {
      color: palette.secondary.main,
    },
  },
  table: {
    width: '100%',
    border: '1px solid #cccccc',
    borderCollapse: 'collapse',
    marginBottom: spacing(2),
    backgroundColor: '#f8f8f8',
  },
  tableCell: {
    border: '1px solid #cccccc',
    padding: spacing(1),
    textAlign: 'center',
    width: '20%',
    height: '40px',
    '& p': {
      margin: 0,
    },
  },
  tableHeaderCell: {
    padding: spacing(1),
    textAlign: 'center',
    fontWeight: 'bold',
    width: '20%',
    height: '40px',
    '& p': {
      margin: 0,
    },
  },
  tableRow: {
    '& p': {
      margin: 0,
    },
  },
}))

export default useStyles
